import { ApiCallActionType } from '../../store.types';
import { getForm } from './getForm';
import { put } from 'redux-saga/effects';
import { Uuid } from '../../../common/common.types';

export type FormsClearAnswersActionType = ApiCallActionType<
  '@forms/API/CLEAR_FORM',
  { id: Uuid }
>;

export const clearAnswers = (id: Uuid): FormsClearAnswersActionType => ({
  type: '@forms/API/CLEAR_FORM',
  payload: {
    callParams: { id },
    endpointPath: ['forms', 'clearAnswers'],
    selector: null,
    postActions: [() => put(getForm({ id }))],
  },
});
